/**
 * IA EVA Domain Constants
 * Sentinel value stored in `Valoration.evaluator_id` when IA EVA is the evaluator.
 */
export const IA_EVA_EVALUATOR_ID = 'IA-EVA';
